export default __webpack_public_path__ + "e69a42f853aaf27fa9a95f4e52702fcf.woff2";